import * as React from 'react';

import Text from '../../../../text/Text.jsx';

export type SurveyCoverProps = {
  headline: React.ReactNode;
  topline: React.ReactNode;
  buttonLabel: React.ReactNode;
  onButtonClick?: () => void;
  duration?: React.ReactNode;
};

const SurveyCover = ({
  headline,
  topline,
  buttonLabel,
  onButtonClick,
  duration
}: SurveyCoverProps) => (
  <div className="survey-cover">
    <Text className="survey-cover__topline" variant="copy" tag="h4">
      {topline}
    </Text>

    <Text className="survey-cover__headline" variant="headline-3" tag="h3">
      {headline}
    </Text>

    <button
      className="survey-cover__button"
      type="button"
      onClick={onButtonClick}
    >
      <Text variant="button" tag="span">
        {buttonLabel}
      </Text>

      <svg width="70" height="9" xmlns="http://www.w3.org/2000/svg">
        <path d="m61 0 9 4.5L61 9V5H0V4h61z" />
      </svg>
    </button>

    {duration && <Text variant="copy-small">{duration}</Text>}
  </div>
);

export default SurveyCover;
